import React, { useState, useRef, useEffect, useContext } from "react";
import ListInfo from "../../CouponCode/ListCouponCode.module.css";
import styles from "./StudentCouponCode.module.css";
import { useNavigate } from "react-router-dom";
import { AxiosInstance } from "../../../../../axios";
import Loader from "../../../Loader";
import Pagination from "../../../../ReusuableComponent/Pagination/Pagination";
import { R_PER_PAGE } from "../../../../../labels";
import { UserContext } from "../../../../../context/UserDetails";
import moment from "moment";

const StudentRewardPoints = () => {
  let page = R_PER_PAGE;
  // use state
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [sortOrder, setSortOrder] = useState("asc");
  const [rewardListData, setRewardListData] = useState();
  const [pointsData, setPoitsData] = useState();
  const { logout } = useContext(UserContext);
  const filterRef = useRef(null);

  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    } else {
      logout();
    }
  } else {
    console.log("User Id cannot available in session storage");
  }

  useEffect(() => {
    loadListdata1();
  }, []);

  //sorting function
  const handleSort1 = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = rewardListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setRewardListData(sortedList);
  };

  //reward list
  function loadListdata1() {
    setIsLoading(true);
    AxiosInstance.post("/api/book/get_user_rewards", { user_id: userid })
      .then((res) => {
        if (res.data.status) {
          setIsLoading(false);
          setCurrentPage(1);
          const fiata = res.data.data;
          setPoitsData(fiata);
          const serialNumberAddedData = fiata?.rewards?.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));

          setRewardListData(serialNumberAddedData);
        } else if (res.data.status === false) {
          setRewardListData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setRewardListData([]);
        setIsLoading(false);
        return error;
      });
  }

  const totalPages = Math.ceil(rewardListData?.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };

  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };

  //reward list
  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = rewardListData?.slice(start, end);

  const handleNavigate = (id) => {
    navigate(`/TransactionHistory/3`);
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div
      className={`${ListInfo.CourseInfoSec} ${styles.cm_ListViewForm} container-fluid BathHeader  global_container p-0`}
    >
      <div className="col-md-6 col-12">
        <h2 className="TitleHeader">Reward Points</h2>
      </div>
      <fieldset className="mt-3">
        <legend className="w-auto">Reward Points</legend>
        <div className="row mb-3">
          <div className="my-1 col-lg-3 col-md-3 col-12">
            <div className="d-flex flex-column">
              <p className="confirm_label m-0 p-0">
                Total Reward Points Balance
              </p>
              <p className="confirm_value my-1 m-0 p-0">
                {" "}
                {pointsData?.total_balance || "_"}
              </p>
            </div>
          </div>
          <div className="my-1 col-lg-3 col-md-3 col-12">
            <div className="d-flex flex-column">
              <p className="confirm_label m-0 p-0">Expiry Date</p>
              <p className="confirm_value my-1 m-0 p-0">
                {/* {pointsData?.expired_date
                  ? moment(pointsData.expired_date).format("DD/MM/YYYY")
                  : "_"} */}

                {pointsData?.expired_date
                  ? moment.utc(pointsData?.expired_date).isValid()
                    ? moment.utc(pointsData?.expired_date).format("DD/MM/YYYY")
                    : "_"
                  : "_"}
              </p>
            </div>
          </div>
        </div>
        <div className="row mt-2 mx-0">
          <div className="col-md-12 table-responsive tableMinHeight px-0">
            <table className="table customTable" id="tableListHeader">
              <thead>
                <tr>
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort1(e, "serialNumber")}
                    >
                      S.No
                    </span>
                    <span
                      className={`textHead_th material-icons align-middle`}
                      onClick={(e) => handleSort1(e, "serialNumber")}
                    >
                      import_export{" "}
                    </span>
                  </th>
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort1(e, "purchase_id")}
                    >
                      {" "}
                      Order ID
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort1(e, "purchase_id")}
                    >
                      import_export
                    </span>{" "}
                  </th>

                  <th id="th" ref={filterRef}>
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort1(e, "created_dt")}
                    >
                      Date
                    </span>
                    <span
                      className={`textHead_th material-icons align-middle`}
                      onClick={(e) => handleSort1(e, "created_dt")}
                    >
                      import_export{" "}
                    </span>
                  </th>
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort1(e, "total_amount")}
                    >
                      {" "}
                      Amount Paid
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort1(e, "total_amount")}
                    >
                      import_export
                    </span>{" "}
                  </th>
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort1(e, "reward_amount")}
                    >
                      {" "}
                      Reward Amount Earned
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort1(e, "reward_amount")}
                    >
                      import_export
                    </span>{" "}
                  </th>
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort1(e, "reward_used")}
                    >
                      {" "}
                      Reward Amount Used
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort1(e, "reward_used")}
                    >
                      import_export
                    </span>{" "}
                  </th>
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort1(e, "reward_balance")}
                    >
                      {" "}
                      Reward Amount Balance
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort1(e, "reward_balance")}
                    >
                      import_export
                    </span>{" "}
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentData?.length === 0 ? (
                  <tr>
                    <td
                      colSpan="15"
                      style={{
                        textAlign: "center",
                        borderBottom: "1px solid #dee2e6",
                      }}
                    >
                      No records to display
                    </td>
                  </tr>
                ) : (
                  currentData?.map((reward, index) => (
                    <tr key={index}>
                      <td id="td">{reward.serialNumber}</td>
                      <td id="td">
                        <p
                          onClick={() => handleNavigate()}
                          className={`my-1 m-0 p-0 ${styles.colorSkyBlue}`}
                          style={{ cursor: "pointer" }}
                        >
                          {reward.purchase_id ? reward.purchase_id : "_"}
                        </p>
                      </td>

                      <td id="td">
                        {`${moment(reward.created_dt).format("DD/MM/YYYY")}`}
                      </td>
                      <td id="td">{reward.total_amount} </td>
                      <td id="td">{reward.reward_amount} </td>
                      <td id="td">{reward.reward_used} </td>
                      <td id="td">{reward.reward_balance} </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="row mt-2">
          <Pagination
            rowsPerPage={rowsPerPage}
            handlePageCount={handlePageCount}
            startPage={
              rewardListData && rewardListData?.length > 0
                ? currentPage * rowsPerPage + 1 - rowsPerPage
                : 0
            }
            endPage={
              rewardListData && rewardListData?.length > 0
                ? rewardListData?.length < currentPage * rowsPerPage
                  ? rewardListData?.length
                  : currentPage * rowsPerPage
                : 0
            }
            totalRecords={
              rewardListData && rewardListData?.length > 0
                ? rewardListData?.length
                : 0
            }
            handlePrev={(e) => handlePrev(currentPage - 1)}
            currentPrevPage={currentPage === 1}
            prevButton={`${ListInfo.prev_buttonViewEvaluator} ${ListInfo.materialIconsRightAndLeft} me-2`}
            handleNext={() => handleNext(currentPage + 1)}
            currentNextPage={currentPage === totalPages || totalPages === 0}
          />
        </div>
      </fieldset>
    </div>
  );
};

export default StudentRewardPoints;
